export const BASE_ERROR404_SHOW = 'BASE_ERROR404_SHOW';
export const BASE_ERROR404_HIDE = 'BASE_ERROR404_HIDE';

export const BASE_SSR_SET_DATA= 'BASE_SSR_SET_DATA';

export const BASE_SEO_SET_META = 'BASE_SEO_SET_META';
export const BASE_SEO_RESET_META = 'BASE_SEO_RESET_META';

export const BOOK_PLAYER_SET_DATA = 'BOOK_PLAYER_SET_DATA';

export const URLS = {
  about: '/about/',
  accountSettings: '/account/edit/',
  accountSubscriptionList: '/account/subscriptions/',
  accountPaymentList: '/account/payments/',
  aboutOffer: '/about/offer/',
  booksetList: '/sets/',
  catalogAudiobooks: '/catalog/books/audio/',
  catalogBookList: '/catalog/books/',
  catalogFreeBookList: '/catalog/books/free/',
  catalogFreeIndex: '/catalog/free/',
  catalogIndex: '/catalog/',
  dashboard: '/dashboard/',
  faq: '/help/',
  activateGift: '/payments/activate_gift/',
  payments: '/payments/',
  authForm: '/account/login/',
  accountResetPassword: '/account/reset-password/',
  search: '/search/',
  accountSetPassword: '/account/set-password/',
  tagList: '/tags/',
  trialCard: '/trial/',
  profile: '/profile/',
  offer: '/offer/',
};

export const SORT_BY_NEW_POPULAR_BOOKS = [
  { value: 'popular', label: 'По популярности' },
  { value: 'new', label: 'По новизне' },
  { value: 'readers', label: 'По количеству читателей' },
  { value: 'reviews', label: 'По оценке' },
];

export const SORT_BY_NEW_POPULAR_AUTHORS = [
  { value: 'popular', label: 'По популярности' },
  { value: 'asc', label: 'По алфавиту' },
  { value: 'book_count', label: 'По количеству книг' },
];

export const FILTER_BY_SUBSCRIPTION = [
  { value: null, type: '', label: 'Все подписки' },
  { value: '0', type: 'free', label: 'Бесплатная' },
  { value: '1', type: 'standard', label: 'Стандартная' },
  { value: '2,3', type: 'premium', label: 'Премиум' },
];

export const FILTER_BY_TYPE = [
  { value: null, label: 'Все книги' },
  { value: 'audio', label: 'Аудиокниги' },
  { value: 'text', label: 'Книги' },
];

export const FILTER_BY_BOOKTYPE = [
  { value: null, type: 'all', label: 'Все' },
  { value: 'text', type: 'text', label: 'Книги' },
  { value: 'audio', type: 'audio', label: 'Аудиокниги' },
];
